import {$array, $util, $idSeed, $event_publisher} from "@util/util.js";
import MainSku from "@core/MainSku.js";
import Constant from "@constant/index.js";
import ViewFactory from "@factory/View.js";
import ActionTool from "@core/ActionTool.js";

export default class Group {
    constructor(){
        this._type = Constant.MODEL_TYPES.GROUP;
        this._id = $idSeed.newId();
        this._mainSkus = [];
        this._itemType = -1;
        this._fid = "";
        this._faName = "";
        this._itemId = "";
        this._isChecked = false;        
        this._invalid = false;

        this._groupMsg = "";
        this._groupDefaultName = "";
        this._groupTag = ""
        //库存和限购提示的文案
        this._purchaseMsg = "";
        this._minStock = null;
        this._minPurchase = null;

        this._data = null;
        // 满减作用域为单品
        this._singleFull = false;
        // wap编辑状态是否选中
        this._isChecked_fake = false;   
    }

    //激活状态
    setActive(){
        if(this._active_status == false){
            return Promise.reject(Constant.MSG.ACTIVEING);
        }
        this._active_status = false;
        return new Promise((resolve, reject)=>{
            ActionTool.setActive({model:this}).then(data=>{
                //价格变动
                $event_publisher.broadcast(Constant.EVENT_KEY.PRICE, data);
                //重新设置Group的属性 + 重新渲染主品
                $event_publisher.broadcast(Constant.EVENT_KEY.CHANGE_PACKAGE_ACTIVE, {model:this, data:data});
                resolve();
                this._active_status = true;
            }).catch(err=>{
                reject(err);
                this._active_status = true;
            })
        })
    }

    //wap编辑状态下选中
    setFakeActive(){ 
        if(this._isChecked_fake){
            this._isChecked_fake = false;
        }else{
            this._isChecked_fake = true;
        }
    }

    //更改数量
    modifyCount(count){
        if(this._modify_count_status == false){
            return Promise.reject(Constant.MSG.MODIFYING);
        }
        this._modify_count_status = false;
        return new Promise((reslove,reject)=>{
            ActionTool.modifyCount({model:this, count:count}).then(data=>{
                //价格变动
                $event_publisher.broadcast(Constant.EVENT_KEY.PRICE, data);
                //重新设置Group
                $event_publisher.broadcast(Constant.EVENT_KEY.MODIFY_PACKAGE_COUNT, {model:this, data:data});
                reslove();
                this._modify_count_status = true;
            }).catch(err=>{
                reject(err);
                this._modify_count_status = true;
            })
        })
    }

    //删除Group
    removeGroup(){
        return new Promise((reslove,reject)=>{
            ActionTool.removeAction({model:this}).then(data=>{
                //价格变动
                $event_publisher.broadcast(Constant.EVENT_KEY.PRICE, data);
                //通知Engine group被删除
                $event_publisher.broadcast(Constant.EVENT_KEY.REMOVE_GROUP, this);
                reslove();
            }).catch(err=>{
                reject(err);
            })
        });
    }

    //获取Group默认名字
    getGroupName(){
        this._groupDefaultName = $util.getGroupNameByType(Constant.GROUP_TYPE, this._itemType);
    }

    //添加主品
    addMainSku(mainSku){
        this._mainSkus.push(mainSku);
    }

    //删除主品
    removeMainSku(mainSku){
        // this._mainSkus = $array.removeItem(this._mainSkus, {_id:mainSku._id});
        // this._mainSkus = $array.removeItem(this._mainSkus, {_itemId:mainSku._itemId});
        for(var i = this._mainSkus.length -1; i >= 0; i--){
            if(this._mainSkus[i]._itemId == mainSku._itemId){
                this._mainSkus.splice(i, 1);
                break;               
            }

        }
    }

    //必须等待Group渲染完毕后才开始渲染MainSku, 因为dom结构必须先拥有parent容器
    readyToReadySku(){
        this._mainSkus.forEach(x=>{
            new ViewFactory().create(Constant.MODEL_TYPES.MAINSKU, x).render();
            x.readyToReadyPromotion();
            x.readyToReadyAdditional();
        })
    }

    initPackage(data){
        this._groupName = "";
        if(data.promotions.length > 0 ){
            this._groupName = data.promotions[0].desc;
        }
        this._groupPrice = data.price.showAmount;
        this._groupCount = data.num;
        this._groupTotalPrice = data.xiaoji.showAmount;
        this._groupPurchaseEnable = data.purchaseEnable;
        this._groupMaxPurchase = data.skus[0].maxPurchase;
        this._groupStock = data.skus[0].stock;
        this._minStock = data.skus[0].stock;
        this._minPurchase =  data.skus[0].maxPurchase;
        data.skus.forEach(item=>{
            if(item.stock < this._minStock){
                this._minStock = item.stock;
            }
            // // 判断赠品的库存 SHOP-39128 不用判断赠品库存
            // if(item.gifts && item.gifts.length>0){
            //     item.gifts.forEach(gift=>{
            //         if(gift.stock < this._minStock){
            //             this._minStock = gift.stock;
            //         }
            //     })
            // }
            if(item.maxPurchase < this._minPurchase){
                this._minPurchase = item.maxPurchase;
            }
        })
        this.getStockMsg();
    }

    getMaxBuyCount(){
        if(this._groupStock > this._groupMaxPurchase){
            return this._groupMaxPurchase;
        }
        return this._groupStock;
    }

    getMaxBuyCount(){
        if(this._minStock > this._minPurchase){
            return this._minPurchase;
        }
        return this._minStock;

    }

    //库存和限购提示的文案
    getStockMsg(){
        
        //商品失效不提示， 不可购买的时候需要提示 这个不知道哪个提过这个需求，需求无效以SHOP-30064为准
        //SHOP-30064 5.当有效商品不可勾选购买时不显示限购和库存的提示信息
        if(this._invalid || this._purchaseEnable == false){
        // if(this._invalid ){
            this._purchaseMsg = "";
            return;
        }

        // SHOP-30064        
        if(this._minStock < this._groupCount ){
            this._purchaseMsg = Constant.MSG.STOCK_NOT_ENOUGH;                
        }else if(this._minStock <= 3 ){
            this._purchaseMsg = Constant.MSG.STOCK;                
        }else if(this._minPurchase <= 5 && this._groupCount >= this._minPurchase){
            this._purchaseMsg = "限购"+this._minPurchase+"件";               
        }else{
            this._purchaseMsg = "";                
        }
        return;        
    }

    init(data){
        this._data = data;
        this._fid = data.id;
        this._faName = data.name;
        this._itemType = data.itemType;
        this._itemId = data.item.itemId;
        this.getGroupName();
        this._isChecked = data.item.check == 0?false:true;
        this._invalid = data.invalid;
        this._purchaseEnable = data.item.purchaseEnable;
        //满减
        if(this._itemType == Constant.GROUP_TYPE.FULL_REDUCE.TYPE){
            this._groupMsg = data.item.stip;
            this._groupTag = (data.item.rePrice && data.item.rePrice.showAmount) >0 ? "再逛逛":"去凑单";
            this._singleFull = data.item.singleFull ? data.item.singleFull : false ;
            //满减有可能是带选件的满减 + 常规满减
            let tmpSkus = data.item.skus;//常规满减
            //带选件的满减
            if(data.item.optItems && data.item.optItems.length >0){ 
                data.item.optItems.forEach(opt=>{
                    tmpSkus.push(opt);
                })
            }
            // 满减的有一个选中，header就显示选中SHOP-37578
            this._isChecked = false; 
            tmpSkus.forEach(x => {
                if(x.check && x.check == 1){
                    this._isChecked = true;
                }
                x._faName = this._faName;
                x._faId = this._fid;
                x._itemType = this._itemType;
                let mainSku = new MainSku();
                mainSku.setParent(this);
                if(x.type == Constant.GROUP_TYPE.OPTION.TYPE){                    
                    mainSku.init(x.skus[0], x);                    
                }else{
                    mainSku.init(x, x);
                }
                // mainSku.init(x, data.item);
                this.addMainSku(mainSku);
            });
        }//单品
        else if(this._itemType == Constant.GROUP_TYPE.SINGLE.TYPE){
            let mainSku = new MainSku();
            mainSku.setParent(this);
            mainSku.init(data.item, data.item);
            this.addMainSku(mainSku);
        }//选件
        else if(this._itemType == Constant.GROUP_TYPE.OPTION.TYPE){
            let mainSku = new MainSku();
            mainSku.setParent(this);
            mainSku.init(data.item.skus[0], data.item);
            this.addMainSku(mainSku);
        }
        //套餐
        else if(this._itemType == Constant.GROUP_TYPE.PACKAGE.TYPE){
            let packageData = data.item;
            this.initPackage(packageData);
            let mainSku = new MainSku();
            mainSku.setParent(this);
            mainSku.init(packageData.skus[0], packageData);
            this.addMainSku(mainSku);
        }
    }
}